import { Link } from "react-router-dom";
import GoogleAuthButton from "./GoogleAuthButton";
import { validatePassword } from "../../common/helpers/common";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import OtherSigninOptions from "./OtherSigninOptions";

function getFormInputs() {
  return [
    {
      type: "text",
      label: "Email",
      name: "email",
      placeholder: "name@example.com",
      validation: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/,
          message: "Invalid email address",
        },
      },
    },
    {
      type: "password",
      label: "Password",
      name: "password",
      placeholder: "Enter at least 8 characters",
      validation: {
        required: "Password is required",
        validate: validatePassword,
      },
      child: (
        <div className="text-right -mt-2">
          <Link
            to="/forgot-password"
            className="back_link hover:underline text-sm"
          >
            Forgot password?
          </Link>
        </div>
      ),
    },
  ];
}

function LoginForm({ onSubmit, isSubmitting }) {
  return (
    <div className="text-gray-700 md:10/12 lg:w-7/12">
      <div className="font-bold text-center my-2 mb-4 text-2xl font-bold">
        LOGIN
      </div>

      <div className="flex justify-center items-center space-x-2 text-gray-500 pb-2">
        <div>Doesn't have an account?</div>

        <div className="text-center">
          <Link to="/signup" className="back_link underline">
            Sign Up
          </Link>
        </div>
      </div>

      <FormBuilder
        formInputs={getFormInputs()}
        submitButtonLabel="Login"
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />

      <OtherSigninOptions />
    </div>
  );
}

export default LoginForm;
